module.exports = __webpack_public_path__ + "static/media/Brochure.80317395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/images/Brochure.svg
// module id = 946
// module chunks = 0